import script from "./goalEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./goalEdit.vue?vue&type=script&setup=true&lang=js"

import "./goalEdit.vue?vue&type=style&index=0&id=d0f87dca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0f87dca"]])

export default __exports__